import { useEffect, useState } from "react";

export const imageSizeText = (width?: number, height?: number) => width && height ? `实际尺寸：${width} × ${height} px（宽 × 高）` : "实际尺寸：暂不可读取";
export function FileDimensions({ file }: { file?: File }) {
  const [source, setSource] = useState<{ file: File; url: string }>();
  useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file); setSource({ file, url });
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return <ImageDimensions src={source?.file === file ? source?.url : undefined} />;
}
export function ImageDimensions({ src }: { src?: string }) {
  const [result, setResult] = useState<{ src: string; width?: number; height?: number }>();
  useEffect(() => {
    if (!src) return;
    let active = true;
    const image = new window.Image();
    image.onload = () => { if (active) setResult({ src, width: image.naturalWidth, height: image.naturalHeight }); };
    image.onerror = () => { if (active) setResult({ src }); };
    image.src = src;
    return () => { active = false; image.onload = null; image.onerror = null; };
  }, [src]);
  if (!src) return null;
  return <span className="material-dimensions">{result?.src === src ? imageSizeText(result.width, result.height) : "正在读取图片尺寸…"}</span>;
}
